import { Box } from '@mui/material';
import React from 'react';
import { themeColors } from '../../JuvareTheme';
export const IconDisplay = () => {
    const sx = { flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' };
    return (React.createElement(Box, { sx: Object.assign({ position: 'absolute', top: 'calc(50% - 52px)', left: 'calc(50% - 52px)', backgroundColor: themeColors.overlay.primaryAlpha, width: 104, height: 104, borderRadius: 52 }, sx) },
        React.createElement(Box, { sx: Object.assign({ backgroundColor: themeColors.overlay.primaryAlpha, width: 72, height: 72, borderRadius: 36 }, sx) },
            React.createElement(Box, { sx: Object.assign({ backgroundColor: themeColors.decorative.white, width: 40, height: 40, borderRadius: 20 }, sx) }))));
};
